import React from "react";
import Select from "react-select";
import { Card, CardBody, CardTitle, Row, Col, Label } from "reactstrap";

const YourComponent = ({
  title,
  data,
  data_files,
  annee,
  setAnnee,
  filtre,
}) => {
  const handleAnneeChange = (e) => {
    setAnnee(e);
  };
  const renderValue = (value) => {
    if (value == null || (typeof value === "string" && value.trim() === "")) {
      return "";
    } else {
      return value;
    }
  };
  const style = { fontFamily: "sans-serif", paddingTop: "10px" };
  return (
    <>
      <CardTitle
        style={{
          fontFamily: "sans-serif",
          color: "#3498db",
          paddingLeft: 15,
          paddingTop: 15,
        }}
        className="mb-3"
      >
        {title}
      </CardTitle>
      <Card>
        <Row>
          <Col sm={8}></Col>
          <Col sm={4} className="d-flex justify-content-end align-items-end">
            <Label>Année de déclaration :</Label>
            <div
              style={{
                paddingLeft: 10,
                paddingTop: 10,
                paddingRight: "inherit",
              }}
            >
              <Select
                defaultValue={annee}
                isClearable={false}
                isSearchable={false}
                className="react-select-container"
                menuPosition="fixed"
                classNamePrefix="react-select"
                options={filtre}
                onChange={handleAnneeChange}
                styles={{
                  control: (provided) => ({ ...provided, width: 150 }),
                }}
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <Row className="mb-3 mt-3 m-lg-1">
              <>
                {data.map((item, index) => (
                  <>
                    {item?.text ? (
                      <p style={{ paddingLeft: 40 }}>{item.text}</p>
                    ) : (
                      <>
                        <Col md="6" key={"_col_" + index}>
                          <Card className="mini-stats-wid">
                            <CardBody>
                              <div className="d-flex">
                                <div className="flex-grow-1">
                                  <p className="text-muted fw-medium">
                                    {item.label}
                                  </p>

                                  <h2 className="mb-0">
                                    {item.value.toLocaleString("fr-FR", {
                                      style: "currency",
                                      currency: "EUR",
                                      minimumFractionDigits: 0,
                                      minimumFractionDigits: 0,
                                    })}
                                  </h2>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </>
                    )}
                  </>
                ))}
              </>
            </Row>
          </Col>
          <Col sm={6}>
            {data_files.map((category, index) => (
              <a
                href={Object.values(category)[0][0].link}
                key={`section_${index}`}
                download
              >
                <Card>
                  <CardBody>
                    {Object.entries(category).map(
                      ([categoryName, documents], index) => (
                        <div key={categoryName}>
                          <CardTitle
                            className="mb-1"
                            style={{ whiteSpace: "pretty" }}
                          >
                            {categoryName}
                          </CardTitle>
                          {documents.map((file, i) => (
                            <Row
                              key={`_file_${i}`}
                              style={{
                                borderBottom:
                                  index !== Object.keys(category).length - 1 ||
                                  i !== documents.length - 1
                                    ? "1px solid #eee"
                                    : "none", // Ne dessine la bordure inférieure que pour toutes les lignes sauf la dernière catégorie et le dernier document de chaque catégorie
                              }}
                            >
                              <Col
                                xs={2}
                                style={{
                                  display: "inline-block",
                                  padding: "10px 0",
                                }}
                              >
                                <div className="avatar-sm">
                                  <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-24">
                                    <i className="bx bxs-file-doc" />
                                  </span>
                                </div>
                              </Col>
                              <Col xs={8} style={{ display: "inline-block" }}>
                                <a
                                  href={file.link}
                                  className="text-dark"
                                  style={{
                                    textDecoration: "none",
                                    display: "block",
                                  }}
                                  download
                                >
                                  <h5
                                    className="font-size-13 mb-1"
                                    style={{
                                      ...style,
                                      paddingLeft: "10px",
                                      display: "inline-block",
                                      paddingTop: 20,
                                    }}
                                  >
                                    {file.title}
                                  </h5>
                                </a>
                              </Col>
                              <Col xs={2}>
                                <div style={{ display: "inline-block" }}>
                                  <a
                                    href={file.link}
                                    className="text-dark"
                                    download
                                  >
                                    <i
                                      className="bx bx-download h3 m-0"
                                      style={{
                                        fontSize: "1.9rem",
                                        paddingTop: 5,
                                      }}
                                    />
                                  </a>
                                </div>
                              </Col>
                            </Row>
                          ))}
                        </div>
                      )
                    )}
                  </CardBody>
                </Card>
              </a>
            ))}
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default YourComponent;
